import {
  IAllStatusInclAll,
  IAPIError_getOrders,
  IApiPaginationResponse,
  IAPIResponse_getOrders,
  IOrder,
  IOrderFilters,
} from 'my-poppies-b2b-types';

import { ICallApiFn } from '@/api/callApi';
import { mockApiCallForOrders } from '@/api/mockApiCallForOrders';
import { IOrderSorting } from '@/types/IOrderSorting';
import { sanitizeFilters } from '@/utils/sanitizeFilters';

export const fetchOrdersFromApi = async (
  callApi: ICallApiFn,
  orderStatus: IAllStatusInclAll,
  page: number,
  pageSize: number,
  filters: IOrderFilters = {},
  sorting: IOrderSorting = { column: 'updatedAt', direction: 'desc' }
): Promise<IApiPaginationResponse<IOrder>> => {
  const filtersSanitized = sanitizeFilters(filters);
  try {
    const response = await callApi(
      'get',
      '/orders',
      {
        params: {
          status: orderStatus,
          page: page + 1,
          size: pageSize,
          sort: sorting.column,
          direction: sorting.direction,
          ...filtersSanitized,
        },
      },
      () => mockApiCallForOrders(orderStatus, page, pageSize, filters, sorting)
    );

    // TODO #12345 remove parsing hack:
    // @ts-expect-error blablabla
    response.itemsOnPage = response.itemsOnPage.map((i) => {
      return {
        ...i,
        positions:
          typeof i?.positions === 'string' ? JSON.parse(i?.positions?.replace(/'/g, '"') ?? '[]') : i?.positions,
      };
    });

    if ((response as IAPIError_getOrders).errorCode) {
      throw new Error('Api Error');
    } else {
      return response as IAPIResponse_getOrders;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return {
      itemsOnPage: [],
      countOnPage: 0,
      pageCountTotal: 0,
      pageCountTotalForFilters: 0,
      countTotalForFilters: 0,
      countTotal: 0,
    };
  }
};
